import { FC } from 'react';

import { useDailyCall } from '../DailyCallProvider/DailyCallProvider';

/**
 * DailyPrebuilt component that renders the container for Daily's Prebuilt UI iframe.
 * Must be used within a DailyCallProvider.
 * The component automatically fills its parent container - size the parent to control dimensions.
 */
export const DailyPrebuilt: FC = () => {
  const { wrapperRef } = useDailyCall();

  return (
    <div
      ref={wrapperRef}
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    />
  );
};
